'use strict'
import fetch from 'isomorphic-fetch'
import { checkAuth, getJson } from '../../utils/ActionUtils'
import ApplicationConf from '../../conf/ApplicationConf'
import { RECEIVE_ALL_CREDIT_TYPE, RECEIVE_USER_CREDIT, RECEIVE_USER_CREDIT_HISTORY, RESET_CREDITS_INFORMATION } from '../constants/CreditConstants'
import HomeAction from './HomeAction'
import i18n from 'simple-react-i18n'
import { template } from 'lodash'
import ToastrAction from './ToastrAction'

const CreditAction = {
	fetchUserInitCredit: function (login) {
		return function (dispatch) {
			return fetch(ApplicationConf.credit.initCredit(), {
				method: 'GET',
				headers: { authorization: btoa('Basic ' + login) }
			})
				.then(() => {
					dispatch(CreditAction.fetchUserCredit(login))
				})
				.catch(err => {
					dispatch(HomeAction.errorOnFetch('fetchUser' + err))
				})
		}
	},
	receiveUserCredit: function (userCredit) {
		return {
			type: RECEIVE_USER_CREDIT,
			userCredit: userCredit
		}
	},
	fetchUserCredit: function (login) {
		return function (dispatch) {
			return fetch(ApplicationConf.credit.userCredit(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ login: login })
			})
				.then(checkAuth)
				.then(getJson)
				.then((json = []) => {
					dispatch(CreditAction.receiveUserCredit(json))
					return json
				}).then((jsonUserCredit) => {
					dispatch(CreditAction.fetchUserCreditHistory(jsonUserCredit[0].id))
				})
				.catch(err => {
					dispatch(HomeAction.errorOnFetch('fetchUser' + err))
				})
		}
	},
	receiveUserCreditHistory: function (userCreditHistory) {
		return {
			type: RECEIVE_USER_CREDIT_HISTORY,
			userCreditHistory: userCreditHistory
		}
	},
	fetchUserCreditHistory: function (idUserCredit) {
		return function (dispatch) {
			return fetch(ApplicationConf.credit.userCreditHystory(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ usercreditid: idUserCredit })
			})
				.then(checkAuth)
				.then(getJson)
				.then((json = []) => {
					dispatch(CreditAction.receiveUserCreditHistory(json))
				}).catch(err => {
					dispatch(HomeAction.errorOnFetch('fetchUser' + err))
				})
		}
	},
	receiveCreditTypes: function (creditTypes) {
		return {
			type: RECEIVE_ALL_CREDIT_TYPE,
			creditTypes: creditTypes
		}
	},
	fetchCreditTypes: function () {
		return function (dispatch) {
			return fetch(ApplicationConf.credit.creditType(), {
				method: 'GET'
			})
				.then(getJson)
				.then((json = []) => {
					dispatch(CreditAction.receiveCreditTypes(json))
				})
				.catch(err => {
					dispatch(HomeAction.errorOnFetch('fetchUser' + err))
				})
		}
	},
	fetchCreditRequest: function (login, creditNumber) {
		return function (dispatch) {
			return fetch(ApplicationConf.credit.creditRequest(), {
				method: 'POST',
				headers: { authorization: btoa('Basic ' + login) },
				body: JSON.stringify({ credit: creditNumber })
			})
				.then(checkAuth)
				.then(() => {
					dispatch(CreditAction.receiveUserCreditHistory([]))
					dispatch(CreditAction.fetchUserCredit(login))
					dispatch(ToastrAction.success(template(i18n.information.successRequestingCredits)({ content: creditNumber })))
				}).catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorRequestingCredits))
				})
		}
	},
	reset() {
		return { type: RESET_CREDITS_INFORMATION }
	}
}

export default CreditAction



// WEBPACK FOOTER //
// ./src/home/actions/CreditAction.js